import React from "react";
import { Clock } from "lucide-react";

/** Tiny pill that visualises an ingest job's SLA state.
 *
 * Reads `sla` from the job document (computed by the backend).
 * Shape: { status, target_days, elapsed_days, remaining_days, completed_at }.
 * status ∈ { "ok", "warn", "overdue", "complete", "not_started" }.
 */
export function SLAPill({ sla, compact = false, testid }) {
  if (!sla) return null;
  const map = {
    ok:          { bg: "bg-emerald-100", fg: "text-emerald-800", label: "On track" },
    warn:        { bg: "bg-amber-100",   fg: "text-amber-800",   label: "Due soon" },
    overdue:     { bg: "bg-red-100",     fg: "text-red-700",     label: "Overdue"  },
    complete:    { bg: "bg-slate-100",   fg: "text-slate-700",   label: "Complete" },
    not_started: { bg: "bg-slate-50",    fg: "text-slate-500",   label: "Not started" },
  };
  const tone = map[sla.status] || map.not_started;
  let detail = "";
  if (sla.status === "complete") {
    detail = sla.elapsed_days != null ? `${sla.elapsed_days}d total` : "";
  } else if (sla.status === "not_started") {
    detail = `${sla.target_days}d target`;
  } else {
    const rem = sla.remaining_days;
    detail = rem >= 0 ? `${rem.toFixed(1)}d left` : `${Math.abs(rem).toFixed(1)}d over`;
  }
  return (
    <span
      data-testid={testid || `sla-${sla.status}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-semibold ${tone.bg} ${tone.fg} ${compact ? "text-[10px] tracking-[0.1em] uppercase" : "text-[11px] tracking-[0.12em] uppercase"}`}
      title={`SLA target ${sla.target_days} days · ${sla.elapsed_days != null ? sla.elapsed_days + "d elapsed" : "not started"}`}
    >
      <Clock className={compact ? "w-2.5 h-2.5" : "w-3 h-3"}/>
      {tone.label}{detail && <span className="opacity-80 normal-case tracking-normal font-mono ml-1.5">· {detail}</span>}
    </span>
  );
}
